/**
 * Ref: https://stackoverflow.com/questions/27889800/javascript-arrays-reordering-an-array-starting-at-a-specified-index-while-kee
 */
export function reorder(data: unknown[], index: number): unknown[] {
  return data.slice(index).concat(data.slice(0, index));
}
